var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMembersTab(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.1 5.6C7.647 5.6 8.9 4.347 8.9 2.8C8.9 1.253 7.647 0 6.1 0C4.553 0 3.3 1.253 3.3 2.8C3.3 4.347 4.553 5.6 6.1 5.6ZM6.1 1.4C6.877 1.4 7.5 2.03 7.5 2.8C7.5 3.57 6.877 4.2 6.1 4.2C5.323 4.2 4.7 3.577 4.7 2.8C4.7 2.023 5.33 1.4 6.1 1.4ZM7.5 11.2H0.5V9.1C0.5 7.231 4.231 6.3 6.1 6.3C6.8 6.3 7.766 6.433 8.697 6.692C8.487 7.084 8.361 7.518 8.347 7.973C7.661 7.77 6.877 7.63 6.1 7.63C4.021 7.63 1.83 8.652 1.83 9.1V9.87H7.5C7.5 9.891 7.5 9.919 7.5 9.94V11.2ZM13.66 9.1V8.05C13.66 7.07 12.68 6.3 11.7 6.3C10.72 6.3 9.74 7.07 9.74 8.05V9.1C9.32 9.1 8.9 9.52 8.9 9.94V12.39C8.9 12.88 9.32 13.3 9.74 13.3H13.59C14.08 13.3 14.5 12.88 14.5 12.46V10.01C14.5 9.52 14.08 9.1 13.66 9.1ZM12.75 9.1H10.65V8.05C10.65 7.49 11.14 7.14 11.7 7.14C12.26 7.14 12.75 7.49 12.75 8.05V9.1Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMembersTab);
export default __webpack_public_path__ + "static/media/membersTab.53972e56.svg";
export { ForwardRef as ReactComponent };